import axios from "axios";
import {HttpResponseType} from "../model/model";

export const restContractorService = async (values: any, action: string, baseUrl: string, params?: string, idEntity?: any) => {
    var _contractorData = {
                        "contractor": {
                            "id": idEntity === undefined ? null : idEntity,
                            "bpCode": values.contractorData?.bpCode,
                            "icaoCode": values.contractorData?.icaoCode,
                            "iataCode": values.contractorData?.iataCode,
                            "companyName": values.contractorData?.companyName,
                            "type": values.contractorData?.type,
                            "notes": values.contractorData?.notes,
                            "currentStatus": values.contractorData?.currentStatus,
                            "royaltiesDued": values.contractorData?.royaltiesDued,
                            "vatNumber": values.contractorData?.vatNumber,
                            "fiscalCode": values.contractorData?.fiscalCode,
                            "idTenant": values.contractorData?.idTenant,
                            "legalAddress": values.contractorData?.legalAddress,
                            "legalStreetNumber": values.contractorData?.legalStreetNumber,
                            "postalCode": values.contractorData?.postalCode,
                            "area": values.contractorData?.area,
                            "areaManager": values.contractorData?.areaManager,
                            "country": values.contractorData?.country,
                            "city": values.contractorData?.city,
                            "region": values.contractorData?.region,
                            "province": values.contractorData?.province,
                            "fax": values.contractorData?.fax,
                            "pec": values.contractorData?.pec,
                            "commercialExecutiveName": values.contractorData?.commercialExecutiveName,
                            "naming": values.contractorData?.naming,
                            "acgIdentificationCode": values.contractorData?.acgIdentificationCode,
                            "serviceType": values.contractorData?.serviceType,
                            "royaltiesPercentage": values.contractorData?.royaltiesPercentage,
                            "bpCodeOfTheRepresentative": values.contractorData?.bpCodeOfTheRepresentative,
                            "taxCode": values.contractorData?.taxCode,
                            "representativeIdentificationCode": values.contractorData?.representativeIdentificationCode,
                            "commercialExecutiveMail": values.contractorData?.commercialExecutiveMail,
                            "prefixCommercialExecutiveDeskPhone": {
                                "code": values.contractorData?.prefixCommercialExecutiveDeskPhone?.code,
                                "description": values.contractorData?.prefixCommercialExecutiveDeskPhone?.description,
                                "label": values.contractorData?.prefixCommercialExecutiveDeskPhone?.label,
                            },
                            "commercialExecutiveDeskPhone": values.contractorData?.commercialExecutiveDeskPhone,
                            "prefixCommercialExecutiveCellPhone": {
                                "code": values.contractorData?.prefixCommercialExecutiveCellPhone?.code,
                                "description": values.contractorData?.prefixCommercialExecutiveCellPhone?.description,
                                "label": values.contractorData?.prefixCommercialExecutiveCellPhone?.label,
                            },
                            "commercialExecutiveCellPhone": values.contractorData?.commercialExecutiveCellPhone,
                            "prefixCellPhoneNumberOfTheContactPerson": {
                                "code": values.contractorData?.prefixCellPhoneNumberOfTheContactPerson?.code,
                                "description": values.contractorData?.prefixCellPhoneNumberOfTheContactPerson?.description,
                                "label": values.contractorData?.prefixCellPhoneNumberOfTheContactPerson?.label,
                            },
                            "cellPhoneNumberOfTheContactPerson": values.contractorData?.cellPhoneNumberOfTheContactPerson,
                            "nameOfTheContactPerson": values.contractorData?.nameOfTheContactPerson,
                            "emailOfTheContactPerson": values.contractorData?.emailOfTheContactPerson,
                            "iban": values.contractorData?.iban,
                            "emailRoyalties": values.contractorData?.emailRoyalties,
                        }
                    }

    async function get(): Promise<HttpResponseType<any>> {
        await axios({
            method: 'get',
            url: baseUrl + params
        })
            .then(function (response) {
                //handle success
                // setEntityState(response.model)
                // delete response.data['documents']
                // delete response.data['id']
                values = response.data
            })
            .catch(function (response) {
                //handle error
                console.log(response);
            });
        return values
    }

    async function update(): Promise<HttpResponseType<any>> {
        await axios({
            method: 'post',
            url: baseUrl + params,
            data: _contractorData,
        })
            .then(function (response) {
                //handle success
                // setEntityState(response.model)
                values = response.data
                //console.log(JSON.stringify(response.data));
                // console.log(entityState);
            })
            .catch(function (response) {
                //handle error
                //console.log(response);
            });
        return values;
    }

    async function insert(): Promise<HttpResponseType<any>> {
        await axios({
            method: 'post',
            url: baseUrl,
            data: _contractorData,
        })
        .then(function (response) {
                //handle success
                // setEntityState(response.model)
                values = response.data
                //console.log(JSON.stringify(response.data));
                // console.log(entityState);
            })
            .catch(function (response) {
                //handle error
                // console.log(response);
            });
        return values;
    }

    async function del(): Promise<HttpResponseType<any>> {
        await axios({
            method: 'delete',
            url: baseUrl + params,
        })
            .then(function (response) {
                //handle success
                // setEntityState(response.model)
                values = response.data
                //console.log(JSON.stringify(response.data));
                // console.log(entityState);
            })
            .catch(function (response) {
                //handle error
                //console.log(response);
            });
        return values;
    }

    async function getAll(): Promise<HttpResponseType<any>> {
        await axios({
            method: 'get',
            url: baseUrl,
        })
            .then(function (response) {
                //handle success
                // setEntityState(response.model)
                delete response.data['documents'];
                delete response.data['id'];
                values = response.data;
                // console.log(entityState);
            })
            .catch(function (response) {
                //handle error
                //console.log(response);
            });
        return values
    }

    async function save(): Promise<HttpResponseType<any>> {
        await axios({
            method: 'post',
            url: baseUrl + params,
            data: _contractorData,
        })
            .then(function (response) {
                //handle success
                // setEntityState(response.model)
                values = response.data
                //console.log(JSON.stringify(response.data));
                // console.log(entityState);
            })
            .catch(function (response) {
                //handle error
                //console.log(response);
            });
        return values;
    }

    switch (action) {
        case 'get':
            return get()

        case 'update':
            return update()

        case 'insert':
            return insert()

        case 'delete':
            return del()

        case 'getAll':
            return getAll()

        case 'save':
            return save()
    }
}
